// Libraries
import React from "react";

// Assets
import "./../assets/styles/Footer.css";
import emailImg from "./../assets/images/email.png";
import linkedInImg from "./../assets/images/linkedIn_trans.png";
import gitHubImg from "./../assets/images/gitHub_trans.png";

// Variables
const email = "mailto:v.yen.sftdev@gmail.com";
const gitHub = "https://github.com/VPYen/"
const linkedIn = "https://www.linkedin.com/in/vyen/";


const Footer = () => {
    return (
        <footer >
            <div id="footerContainer">
                <ul id="socialLinks">
                    <li className="zoom"><a href={email} target="_blank"><img src={emailImg} alt="Email" id="email"/></a></li>
                    <li className="zoom"><a href={linkedIn} target="_blank"><img src={linkedInImg} alt="LinkedIn" id="linkedin"/></a></li>
                    <li className="zoom"><a href={gitHub} target="_blank"><img src={gitHubImg} alt="GitHub" id="github"/></a></li>
                </ul>
                <div id="copyright">
                    <p>© Copyright 2024 Vincent Yen. All Rights Reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;